module.exports = __webpack_public_path__ + "media/images/iconDelete__accent-895432b0335055ef2581b4498b77a628.png";